"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputChangedHandler = exports.checkValidity = exports.checkFileValidity = exports.formatBytes = exports.NameContentConfig = exports.NameContentConfigs = exports.File = void 0;
var tslib_1 = require("tslib");
var File = /** @class */ (function () {
    function File(name, value, size) {
        this.name = name;
        this.value = value;
        this.size = size;
    }
    return File;
}());
exports.File = File;
var NameContentConfigs = /** @class */ (function () {
    function NameContentConfigs() {
        this.legal = new NameContentConfig();
        this.major = new NameContentConfig();
    }
    return NameContentConfigs;
}());
exports.NameContentConfigs = NameContentConfigs;
var NameContentConfig = /** @class */ (function () {
    function NameContentConfig() {
        (this.useWebsiteOnMobileSuggestionEnabled = true),
            (this.fileFormatKeyDefault = true),
            (this.fileCount = 0),
            (this.mailingEnabled = false),
            (this.isIdProofNeeded = false),
            (this.isAddressProofNeeded = false),
            (this.isLegalProofNeeded = false),
            (this.addressProofKeys = []),
            (this.legalProofKeys = []);
    }
    return NameContentConfig;
}());
exports.NameContentConfig = NameContentConfig;
function formatBytes(bytes, decimals) {
    if (bytes == null || bytes == 0)
        return "0 Bytes";
    var k = 1024, dm = decimals <= 0 ? 0 : decimals || 2, sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
exports.formatBytes = formatBytes;
function checkFileValidity(file, nameContent) {
    var isValidType = false, isValidName = false, isValidSize = false;
    var permittedFileSize = 5242880, permittedNameLength = 40;
    var errorMessage;
    if (file.name && file.name.length <= permittedNameLength) {
        isValidName = true;
    }
    else {
        errorMessage = nameContent.error.maxFileName;
    }
    if (file.size && file.size <= permittedFileSize) {
        isValidSize = true;
    }
    else {
        errorMessage = nameContent.error.maxFileSize;
    }
    if (file.type &&
        (file.type == "image/png" ||
            file.type == "image/jpeg" ||
            file.type == "application/pdf")) {
        isValidType = true;
    }
    else {
        errorMessage = nameContent.error.fileType;
    }
    return {
        isValid: isValidType && isValidName && isValidSize,
        errorMessage: errorMessage,
    };
}
exports.checkFileValidity = checkFileValidity;
function checkValidity(value, rules) {
    var isValid = true;
    if (!rules) {
        return true;
    }
    if (rules.required) {
        isValid = value.trim() !== "" && isValid;
    }
    return isValid;
}
exports.checkValidity = checkValidity;
function inputChangedHandler(event, inputIdentifier, state, setState) {
    var updatedForm = tslib_1.__assign({}, state.pageInputs);
    var subForm = updatedForm[state.pageName].form;
    var updatedFormElement = tslib_1.__assign({}, subForm[inputIdentifier]);
    updatedFormElement.value = event.target.checked
        ? event.target.checked
        : event.target.value;
    updatedFormElement.value =
        (event.currentTarget && event.currentTarget.value) ||
            updatedFormElement.value;
    updatedFormElement.isValid = checkValidity(updatedFormElement.value, updatedFormElement.validation);
    updatedFormElement.isTouched = true;
    subForm[inputIdentifier] = updatedFormElement;
    subForm[inputIdentifier]["formMessage"] = "";
    var formIsValid = true;
    // tslint:disable-next-line:no-for-in forin
    for (var identifier in subForm) {
        formIsValid =
            !subForm[identifier].isTouched ||
                (subForm[identifier].isValid && formIsValid);
    }
    updatedForm[state.pageName]["formIsValid"] = formIsValid;
    updatedForm[state.pageName]["formMessage"] = "";
    setState({
        pageInputs: updatedForm,
    });
}
exports.inputChangedHandler = inputChangedHandler;
